'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var styled = require('styled-components');
var nthBitHeader = require('@narvar/nth-bit-header');
var Paragraph = require('@narvar/nth-bit-paragraph');
var Button = require('@narvar/nth-block-button');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index$1 = require('../../../../common/components/Icon/index.js');
var PageWrapper = require('../../../../common/components/layout/PageWrapper.js');
var index = require('../../../../common/providers/ClaimBuilder/index.js');
var SessionContext = require('../../../../common/providers/SessionContext.js');
var useAnalytics = require('../../../../common/providers/useAnalytics.js');
var ConfirmationViewRoot = require('../../../../common/views/Confirmation/ConfirmationViewRoot.js');
var ConfirmationProvider = require('../../../../common/views/Confirmation/ConfirmationProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const Container = styled__default["default"].div.withConfig({
  componentId: "sc-1x8fapk-0"
})(["display:flex;flex-direction:column;align-items:center;text-align:center;"]);
const Spacer = styled__default["default"].div.withConfig({
  componentId: "sc-1x8fapk-1"
})(["padding-bottom:1rem;"]);
const Confirmation = () => {
  const {
    state: {
      claimType
    }
  } = index.useClaimBuilder();
  const {
    claimsConfirmationTitle,
    claimsConfirmationDescription,
    claimsConfirmationButton
  } = nthHookTranslations.useTranslations();
  const {
    orderNumber
  } = SessionContext.useSession();
  const logEvent = useAnalytics["default"]();
  const {
    customerUrl
  } = nthHookSettings.useSettings();
  const {
    email
  } = ConfirmationProvider.useConfirmation();
  const onConfirmation = () => {
    if (!customerUrl) return;
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.CONTINUE_SHOPPING_CLICK,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_CONFIRMATION,
      page_step: useAnalytics.ClaimsPageStep.CONFIRMATION,
      order_number: orderNumber,
      claim_reason: claimType
    });
    window.location.href = customerUrl;
  };
  return /*#__PURE__*/React__default["default"].createElement(PageWrapper["default"], null, /*#__PURE__*/React__default["default"].createElement(Container, null, /*#__PURE__*/React__default["default"].createElement(Spacer, null, /*#__PURE__*/React__default["default"].createElement(index$1.IconThemed, {
    icon: "CheckMarkCircleOutlined"
  })), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, null, claimsConfirmationTitle), /*#__PURE__*/React__default["default"].createElement(Spacer, null, /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, mustache__default["default"].render(claimsConfirmationDescription ?? '', {
    email
  }))), customerUrl && /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    onClick: onConfirmation
  }, claimsConfirmationButton)));
};
const ConfirmationWithProviders = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(Confirmation, {
  translationKeys: ['claimsConfirmationTitle', 'claimsConfirmationDescription', 'claimsConfirmationButton']
}), {
  settingsRequested: 'customerUrl'
});
const ConfirmationWithViewRoot = () => {
  return /*#__PURE__*/React__default["default"].createElement(ConfirmationViewRoot["default"], null, /*#__PURE__*/React__default["default"].createElement(ConfirmationWithProviders, null));
};

exports["default"] = ConfirmationWithViewRoot;
